import { Close } from '@mui/icons-material'
import {
    Divider,
    Grid,
    Container,
    TextField,
    MenuItem,
    DialogTitle,
    Dialog,
    Card,
    CardContent,
    IconButton,
    Typography,
} from '@mui/material'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { ActionButton } from '../../../utils/ui_utils'

function TablesDrawer({
    createMode,
    initialValues,
    okText,
    onClose,
    onSubmit,
    floorsData,
    visible,
    title,
    outlet
}) {

    if (initialValues == undefined)
        initialValues = {
            name: '',
            price_id: '',
            floor_id: '',
        }

    if (outlet === undefined || outlet === null) {
        outlet = ""
    }

    if (floorsData == undefined)
        floorsData = []

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Required').min(2, 'Min length is 2 character'),
        price_id: Yup.number().required('Required').min(1, 'Price id must be 1, 2 or 3.').max(3, 'Price id must be 1, 2 or 3.'),
        floor_id: Yup.string().required('Required'),
        from: Yup.number().required('Required').min(1, 'Min length is 1 character'),
        to: Yup.number().required('Required').min(Yup.ref('from'), 'To must be greater than or equal to from'),
    })

    const handleSubmit = (values, { resetForm, setErrors, setStatus, setSubmitting }) => {
        onSubmit(values)
    }

    return (
        <>
            <Dialog
                open={visible}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle sx={{ "display": "flex", "justifyContent": "space-between", alignItems: "center" }}>
                    {title}
                    <IconButton
                        component="span"
                        size='small'
                        sx={{ ':hover': { backgroundColor: "red", color: "white" } }}
                        onClick={onClose}
                        variant="contained"
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <Container sx={{ marginBottom: 5 }} >
                    <Divider my={2} />
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}

                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values,
                            setFieldValue,
                            status,
                        }) => (

                            <form onSubmit={handleSubmit}>
                                <Card>
                                    <CardContent>
                                        
                                        <Grid container spacing={6} >
                                            <Grid item md={6}>
                                                <TextField
                                                    size="small"
                                                    name="name"
                                                    label="Name"
                                                    autoFocus
                                                    value={values.name}
                                                    error={Boolean(touched.name && errors.name)}
                                                    helperText={touched.name && errors.name}
                                                    fullWidth
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    my={2}
                                                />
                                            </Grid>
                                            <Grid item md={6}>
                                                <TextField
                                                    size="small"
                                                    name="price_id"
                                                    label="Price Id"
                                                    value={values.price_id}
                                                    error={Boolean(touched.price_id && errors.price_id)}
                                                    helperText={touched.price_id && errors.price_id}
                                                    fullWidth
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    onChange={handleChange}
                                                    type="number"
                                                    variant="outlined"
                                                    my={2}
                                                />
                                            </Grid>
                                        </Grid>
                                        {createMode ? (
                                            <Grid container  >
                                              <Grid item md={12} pt={2}>    
                                       <Typography sx={{ fontSize: 12, pl:1}} color="text.secondary">
                                                  Range
                                                    </Typography>
                                                          </Grid> 
                                                           <Grid item md={12} > 
                                                    <Card title="Range" variant="outlined" >
                                                   <Grid container  spacing={5} p={2}>
                                            <Grid item md={6} 
                                            >
                                                 <TextField
                                                    size="small"
                                                    name="from"
                                                    label="From"
                                                    value={values.from}
                                                    error={Boolean(touched.from && errors.from)}
                                                    helperText={touched.from && errors.from}
                                                    fullWidth
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    onChange={handleChange}
                                                    type="number"
                                                    variant="outlined"
                                                    my={2}
                                                />
                                            </Grid>
                                            <Grid item md={6}>
                                                <TextField
                                                    size="small"
                                                    name="to"
                                                    label="To"
                                                    value={values.to}
                                                    error={Boolean(touched.to && errors.to)}
                                                    helperText={touched.to && errors.to}
                                                    fullWidth
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    onChange={handleChange}
                                                    type="number"
                                                    variant="outlined"
                                                    my={2}
                                                />
                                            </Grid>
                                        </Grid>
                                                    </Card> 
                                                    </Grid> 
                                            </Grid>
                                        
                                        ) : (
                                                <></>
                                    )
                                        }

                                        <Grid container spacing={6}pt={2}>
                                            <Grid item md={6}>
                                                <TextField
                                                    size="small"
                                                    name="outlet"
                                                    id="outlet"
                                                    label="Outlet"
                                                    value={outlet}
                                                    error={Boolean(touched.outlet && errors.outlet)}
                                                    fullWidth
                                                    onBlur={handleBlur}
                                                    margin="dense"

                                                    disabled
                                                    variant="outlined" />
                                            </Grid>

                                            <Grid item md={6}>

                                                <TextField
                                                    size="small"
                                                    id="service_floor_select"
                                                    name="floor_id"
                                                    label="Service Floor"
                                                    value={values.floor_id}
                                                    error={Boolean(touched.floor_id && errors.floor_id)}
                                                    fullWidth
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    select
                                                >
                                                    {floorsData.length > 0 ?
                                                        floorsData.map((floor) => (
                                                            <MenuItem key={floor._id} value={floor._id}>
                                                                {floor.name}
                                                            </MenuItem>
                                                        )) :
                                                        <MenuItem value="">
                                                            <em>None</em>
                                                        </MenuItem>

                                                    }
                                                </TextField>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                                <Grid container justifyContent="flex-end">
                                    <Grid item  >
                                        <ActionButton variant="outlined" size='medium' type="submit" mt={8}>
                                            {okText}
                                        </ActionButton>
                                    </Grid>
                                </Grid>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Dialog>
        </>
    );

}

export default TablesDrawer;